import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { interviewAvailabilityShape } from '../../../../../dateUtils';
import { deleteRequest } from '../../../../../requestUtils';
import { analyticsTrack } from '../../../../../analyticsUtils';
import InterviewAttendees from '../../../../common/InterviewSubComponents/InterviewAttendees';
import InterviewTimeRange from '../../../../common/InterviewSubComponents/InterviewTimeRange';
import InterviewTimezone from '../../../../common/InterviewSubComponents/InterviewTimezone';
import InterviewActions from '../../../../common/InterviewSubComponents/InterviewActions';

function PendingInterviewCard({
  interview,
  possibleInterviewers,
  invitableRoles,
  consultantView,
  csrfToken,
  editModalRef,
  canEdit,
  canCancel,
  onCancel,
  interviewType,
  newInterviewSlot,
  availableInterviewSlotUrl,
}) {
  const location = 'Proposal Page View';
  const copy = consultantView ? 'You have' : `${interview.attendees.consultant.split(' ')[0]} has`;
  const handleCancelInterview = () => {
    deleteRequest(interview.cancel_interview_path, csrfToken).then(
      (response) => {
        analyticsTrack('Interview cancelled; type: pending', location);
        onCancel(interview.id, response, 'pending');
      },
    );
  };

  return (
    <Fragment>
      <div className="interview-info-container">
        <div className="interview-info-header upcoming">
          <h2 className="medium-weight mb-8">Interview pending confirmation</h2>
          <div className="normal-weight body-text-2 mb-4">
            {copy}
            {' '}
            not selected a time yet.
            &nbsp;
            All guests will be notified when a time is selected.
          </div>
        </div>
        <InterviewAttendees
          attendees={interview.attendees}
          consultantView={consultantView}
        />
        <hr className="half-width" />
        <div className="interview-availabilities-container body-text-2">
          <div className="interview-availabilities-header medium-weight mb-12">
            Your availability for this interview:
          </div>
          <div className="interview-availabilities-timezone normal-weight muted-gray-text mb-12">
            <InterviewTimezone
              timezoneStr={interview.timezone}
            />
          </div>
          <div className="interview-availabilities-list">
            {interview.availabilities.map((availability) => (
              <InterviewTimeRange
                interviewTime={availability}
                opts={{
                  timeZone: 'UTC',
                  weekday: 'long',
                  month: 'short',
                  day: 'numeric',
                }}
                containerClassName="interview-availability-item normal-weight mb-8"
                key={`${availability.start_time}${availability.date}`}
              />
            ))}
          </div>
        </div>
      </div>
      { (canEdit || canCancel)
      && (
      <Fragment>
        <hr />
        <InterviewActions
          interview={interview}
          interviewType={interviewType}
          editInterviewPath={interview.edit_interview_path}
          csrfToken={csrfToken}
          possibleInterviewers={possibleInterviewers}
          invitableRoles={invitableRoles}
          editModalRef={editModalRef}
          canEdit={canEdit}
          canCancel={canCancel}
          location="Proposal Page"
          onCancel={() => handleCancelInterview()}
          newInterviewSlot={newInterviewSlot}
          availableInterviewSlotUrl={availableInterviewSlotUrl}
        />
      </Fragment>
      )}
    </Fragment>
  );
}

PendingInterviewCard.propTypes = {
  interview: PropTypes.shape({
    id: PropTypes.number.isRequired,
    round_number: PropTypes.number.isRequired,
    timezone: PropTypes.string.isRequired,
    attendees: PropTypes.shape({
      consultant: PropTypes.string,
      invitees: PropTypes.arrayOf(PropTypes.string),
      requester: PropTypes.string,
    }).isRequired,
    availabilities: PropTypes.arrayOf(interviewAvailabilityShape),
    edit_interview_path: PropTypes.string.isRequired,
  }).isRequired,
  possibleInterviewers: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  invitableRoles: PropTypes.arrayOf(PropTypes.string).isRequired,
  editModalRef: PropTypes.func.isRequired,
  canEdit: PropTypes.bool.isRequired,
  canCancel: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  consultantView: PropTypes.bool.isRequired,
  csrfToken: PropTypes.string.isRequired,
  interviewType: PropTypes.string.isRequired,
  newInterviewSlot: PropTypes.bool.isRequired,
  availableInterviewSlotUrl: PropTypes.string.isRequired,
};

export default PendingInterviewCard;
